<template>
  <div>
    <div style="text-align: right;margin-bottom: 5px;">
      <span>
        Viendo documentos que fueron <strong>creados</strong>
      </span>
      <span v-if="rangeSelected.valor !== 'personalizado'">
         en
        {{ rangeSelected.nombre }}
      </span>
      <span v-if="rangeSelected.valor === 'personalizado'">
        entre el
        <!--<input type="date" class="fecha" v-model="periodoDesde">-->
        <datetime
          v-model="rangeFrom"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar',
           cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="start-time"
        />
        y el
        <datetime
          v-model="rangeUntil"
          input-class="input-date"
          :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
          value-zone="local"
          format="yyyy-MM-dd"
          data-cy="end-time"
        />
      </span>
      <vs-dropdown vs-trigger-click
                   style="margin-left: 15px"
                   data-cy="change-date">
        <a class="a-icon" href="#">
          Cambiar
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>
        <vs-dropdown-menu>
          <vs-dropdown-item
            style="width:200px"
            v-for="range in ranges"
            :key="range.valor"
            v-on:click.native="selectRange(range)"
            data-cy="change-date-item"
          >
            {{ range.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div style="float:left">
      <vs-chip
        style="cursor:pointer;"
        v-if="filtrosAplicados.length > 0"
        v-on:click.native="setFilters()"
        data-cy="setFilters"
      >
        <vs-avatar icon="search" color="primary" :badge="filtrosAplicados.length"/>
        <strong>Buscar</strong>
      </vs-chip>
      <vs-chip
        style="cursor:pointer;"
        color="danger"
        v-if="filtrosAplicadosFiltered.length > 0"
        v-on:click.native="clearAllFilters()"
        data-cy="clearAllFilters"
      >
        <vs-avatar icon="clear_all" color="danger"/>
        <strong>Limpiar filtros</strong>
      </vs-chip>
      <vs-chip
        style="cursor:pointer;"
        color="gray"
        v-if="!filtrosAplicados.length"
        v-on:click.native="setFilters()"
      >
        <vs-avatar icon="search" color="primary"/>
        <strong>Buscar</strong>
      </vs-chip>
      <vs-chip
        :color="colores.navbar"
        v-if="hasQueryFilters"
        style="cursor: context-menu"
        v-on:click.native="clearQueryFilters()"
      >
        <vs-avatar icon="link" color="primary"/>
        <strong>Borrar filtros de enlace</strong>
      </vs-chip>
    </div>
    <div style="float:right">
      <vs-dropdown vs-trigger-click data-cy="add-filter">
        <vs-chip color="primary">
          <vs-avatar
            icon="add"
            color="primary"
          />
          Agregar filtro
        </vs-chip>
        <vs-dropdown-menu class="scroll-options" data-cy="list">
          <vs-dropdown-item
            v-for="(filter, index) in filtrosDisponibles"
            :key="`filter-${ index }`"
            v-on:click="addFilter(filter)"
            style="width:200px"
          >
            {{ filter.nombre }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <vs-chip
      color="primary" transparent
      v-for="(filtro, index) in filtrosAplicadosFiltered"
      :key="`filtro-aplicado-${ index }`"
      style="cursor: context-menu"
    >
      <vs-avatar
        icon="clear"
        v-on:click.native="removeFilter(filtro)"
        color="primary"
      />
      <span/>
      <vs-tooltip
        :text="`Modificar filtro ${filtro.nombre}`"
        v-on:click.native="modificarFiltro(filtro)"
      >
        <strong>{{ filtro.nombre }}: </strong>
        <span class="pl-1">
          {{ filtro.valorFormateado }}
        </span>
      </vs-tooltip>
    </vs-chip>
    <b-modal
      :title="`Filtrar por ${actualFilter.nombre}`"
      ref="configFiltro"
      @cancel="closeModal(actualFilter)"
      @close="closeModal(actualFilter)"
      no-close-on-backdrop
      centered
      hide-footer
      :hide-header-close="editMood"
    >
      <div>
        <div v-if="actualFilter.tipo === 'selector-empresa'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.optionsEmpresa"
              name="options"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selector-doc'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.optionsDoc"
              name="options"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selector-autor'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.optionsAutor"
              name="options"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selector-tema'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.optionsTema"
              name="options"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'selector-subtema'">
          <div class="texto-normal">
            <v-select
              :options="actualFilter.opciones"
              v-model="filterOptions.optionsSubtema"
              name="options"
              multiple
            >
              <template slot="no-options">
                no hay coincidencias para el criterio de búsqueda
              </template>
            </v-select>
          </div>
        </div>
        <div v-if="actualFilter.tipo == 'multi'">
          <div v-if="actualFilter.valor.length==1" class="alerta">
            Debe seleccionar como mínimo 1 de las opciones. Seleccione otra
            opción antes de desmarcar la actual si es que desea cambiarla.
          </div>
          <vs-checkbox
            v-model="selectAllOptions"
            class="modal-opcion"
            v-on:change.native="selectFilter(actualFilter)"
          >
            Seleccionar Todos
          </vs-checkbox>
          <hr/>
          <br/>
          <div
            v-for="[valor, nombre] in Object.entries(actualFilter.opciones)"
            v-bind:key="nombre"
            class="modal-opcion"
          >
            <vs-checkbox
              v-model="actualFilter.valor"
              :vs-value="valor"
              v-on:change.native="selectFilter(actualFilter)"
              :disabled="actualFilter.valor.length === 1 && actualFilter.valor.includes(valor)"
            >
              {{ nombre }}
            </vs-checkbox>
          </div>
        </div>
        <div v-if="actualFilter.tipo== 'texto'">
          <div class="texto-normal">
            <!--<vue-tags-input
              v-model="tag"
              :tags="tags"
              @tags-changed="newTags => tags = newTags"
              placeholder="Agregar"
              :separators="[',']"
            />-->
            <tags-input
              element-id="tags"
              v-model="tags"
              add-tags-on-blur
              add-tags-on-comma
              placeholder="Agregar"
              :typeahead="true"
            />
          </div>
          <div v-if="source === 'egestion'" class="mt-3">
            <vs-checkbox v-model="coincidencia">
              Buscar por coincidencia
            </vs-checkbox>
            <small class="text-muted d-block mt-1">
              Encuentra documentos que contengan el texto ingresado en cualquier parte.
            </small>
          </div>
        </div>
        <div v-if="actualFilter.tipo== 'fecha'">
          <div class="texto-normal">
            <datetime
              input-class="input-date"
              v-model="actualFilter.valor"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local" format="yyyy-MM-dd"
            />
          </div>
        </div>
        <div v-if="actualFilter.tipo === 'rangoFecha'">
          <div class="swtich-tipo-rango d-flex justify-content-between">
            <div class="rango-parte">Rango Simple</div>
            <div class="rango-parte rango-switch">
              <vs-switch v-model="tipoRangoFechaAvanzado"/>
            </div>
            <div class="rango-parte">Rango Avanzado</div>
          </div>
          <hr/>
          <div v-if="!tipoRangoFechaAvanzado">
            <div class="center">
              <template
                v-for="(periodo, index) in periodos"
              >
                <vs-button
                  :disabled="periodo.valor === actualFilter.valor"
                  size="medium" color="primary" type="filled"
                  v-on:click="seleccionarRango(periodo.valor)"
                  class="w-full mb-1"
                  :key="`periodo-${index}`"
                >
                  {{ periodo.nombre.charAt(0).toUpperCase() + periodo.nombre.slice(1) }} <br/>
                  <span style="font-size: 80%">
                    (desde el {{ formatoTipoRango(periodo.valor, true) }} hasta hoy)
                </span>
                </vs-button>
              </template>
            </div>
          </div>
          <div v-if="tipoRangoFechaAvanzado">
            entre el
            <datetime
              v-model="rangoAvanzado.desde"
              input-class="input-date"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local" format="yyyy-MM-dd"
              data-cy="start-time"
            />
            y el
            <datetime
              v-model="rangoAvanzado.hasta"
              input-class="input-date" :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
              format="yyyy-MM-dd"
              data-cy="end-time"
            />
          </div>
        </div>
      </div>
      <div class="text-center mt-2">
        <vs-button size="small" v-on:click="verificarFiltrosAlCerrar">
          Confirmar
        </vs-button>
      </div>
    </b-modal>
  </div>
</template>
<script>

import { mapGetters, mapState } from 'vuex';
import Vue from 'vue';

import { DATE_RANGE_LAST_3_MONTH, DATE_RANGES, aliasToDate } from '@/febos/chile/commons/dateCommons';
import SelectorDateMixin from '@/febos/global/_vue/componentes/filtersLetty/SelectorDateMixin';

export default {
  components: {},
  props: {
    filtersView: {
      type: Object,
      required: true
    },
    periodos: {
      type: Array,
      required: false
    },
    source: {
      type: String,
      default: null
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    }
  },
  mixins: [SelectorDateMixin],
  data() {
    const range = this.defaultDate ? this.defaultDate : DATE_RANGE_LAST_3_MONTH;
    return {
      ranges: this.periodos || DATE_RANGES,
      rangeSelected: range,
      editMood: false,
      modalFilter: false,
      rangeFrom: '',
      rangeUntil: '',
      actualFilter: {},
      filtrosAplicados: [],
      filtrosDisponibles: [],
      selectAllOptions: false,
      tipoRangoFechaAvanzado: false,
      tipoRango: false,
      fechaSimpleActual: '',
      rangoAvanzado: {
        desde: '',
        hasta: ''
      },
      tag: '',
      tags: [],
      coincidencia: false,
      filterOptions: {
        optionsEmpresa: [],
        optionsDoc: [],
        optionsAutor: [],
        optionsTema: [],
        optionsSubtema: []
      }
    };
  },
  created() {
    this.selectRange(this.rangeSelected, true);
  },
  watch: {
    // eslint-disable-next-line func-names
    'actualFilter.valor': function (nuevoValor) {
      if (this.actualFilter.tipo === 'fecha') {
        this.actualFilter.valor = Vue.moment(nuevoValor).format('YYYY-MM-DD');
        this.actualFilter.valorFormateado = Vue.moment(nuevoValor).format('YYYY-MM-DD');
      }
    },
    // eslint-disable-next-line func-names
    'actualFilter.valorFormateado': function (nuevoValor) {
      this.actualFilter.valorFormateado = nuevoValor;
    },
    // eslint-disable-next-line func-names
    'filterOptions.options': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.optionsEmpresa': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.optionsDoc': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.optionsAutor': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.optionsTema': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    // eslint-disable-next-line func-names
    'filterOptions.optionsSubtema': function (valorNuevo) {
      this.actualFilter.valor = valorNuevo.map((option) => option.id);
      this.actualFilter.valorFormateado = valorNuevo.map((option) => option.label).join(',');
    },
    rangoAvanzado: {
      handler(valor) {
        this.$log.debug('watch.rangoAvanzado');
        this.$log.info('valor rango avanzado', valor);
        try {
          const desde = valor.desde.split('T')[0];
          const hasta = valor.hasta.split('T')[0];
          this.actualFilter.valor = `${desde}--${hasta}`;
        } catch (e) {
          this.$log.info('Una de las fechas de rango avanzado no esta correctamente '
            + 'formateada,se necesitan ambas para setear el valor del filtro');
        }
        this.seleccionarRango(this.actualFilter.valor);
      },
      deep: true
    },
    tipoRangoFechaAvanzado() {
      if (!this.actualFilter.valor.includes('--') && !this.actualFilter.valor.includes(' ')) {
        this.rangoAvanzado.desde = this.formatoTipoRango(this.actualFilter.valor);
        this.rangoAvanzado.hasta = Vue.moment().subtract(0, 'days').format('YYYY-MM-DD');
        this.actualFilter.valor = `${this.rangoAvanzado.desde}--${this.rangoAvanzado.hasta}`;
        // this.seleccionarRango(this.actualFilter.valor);
      } else {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.rangoAvanzado.desde = desde;
        this.rangoAvanzado.hasta = hasta;
      }
    },
    tags(valorNuevo) {
      const valor = valorNuevo;
      this.actualFilter.valor = valor.map((tag) => tag.value); // .join(",");
      this.actualFilter.valorFormateado = valor.map((tag) => tag.value).join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          return {
            ...filterApplied,
            valor: valor.map((tag) => tag.value).join(','),
            valorFormateado: valor.map((tag) => tag.value).join(', ')
          };
        }
        return filterApplied;
      });
    },
    selectAllOptions(valorNuevo) {
      if (valorNuevo === true) {
        if (this.actualFilter.valor.length !== Object.keys(this.actualFilter.opciones).length) {
          this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
          this.actualFilter.valorFormateado = Object.values(this.actualFilter.opciones);
        }
      } else {
        this.actualFilter.valor = [];
        this.actualFilter.valorFormateado = [];
      }
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    }),
    filtrosAplicadosFiltered() {
      return this.filtrosAplicados.filter((filtro) => filtro.valor !== '');
    }
  },
  methods: {
    selectRange(range, fromCreated = false) {
      // Rango predefinido: calcular fechas segun el mixin y buscar
      if (range.valor !== 'personalizado') {
        const { rangeFrom, rangeUntil } = aliasToDate(range.valor);
        this.rangeFrom = rangeFrom;
        this.rangeUntil = rangeUntil;
      }
      this.rangeSelected = range;
      if (!fromCreated && range.valor !== 'personalizado') {
        this.setFilters();
      }
    },
    clearOptions() {
      this.tag = '';
      this.tags = [];
    },
    clearAllFilters() {
      this.filtrosAplicados = [];
      this.selectAllOptions = false;
      this.filterOptions = {
        options: [],
        optionsEmpresa: [],
        optionsDoc: [],
        optionsAutor: [],
        optionsTema: [],
        optionsSubtema: []
      };
      this.clearOptions();
      // Relanzar busqueda solo con la fecha
      this.setFilters();
    },
    removeFilter(filter) {
      this.filtrosAplicados = this.filtrosAplicados
        .filter((filterApplied) => filterApplied.campo !== filter.campo);
      switch (filter.tipo) {
        case 'selector': {
          this.filterOptions.options = [];
          break;
        }
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        case 'selector-empresa': {
          this.filterOptions.optionsEmpresa = [];
          break;
        }
        case 'selector-doc': {
          this.filterOptions.optionsDoc = [];
          break;
        }
        case 'selector-autor': {
          this.filterOptions.optionsAutor = [];
          break;
        }
        case 'selector-tema': {
          this.filterOptions.optionsTema = [];
          break;
        }
        case 'selector-subtema': {
          this.filterOptions.optionsSubtema = [];
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
    },
    formatoTipoRango(formato, humano = false) {
      const estilo = humano ? 'LL' : 'YYYY-MM-DD';
      switch (formato) {
        case 'ultimas4semanas':
          return Vue.moment().subtract(28, 'days').format(estilo);
        case 'esteMes':
          return Vue.moment().startOf('month').format(estilo);
        case 'esteMesConAnterior':
          return Vue.moment().subtract(1, 'month').startOf('month').format(estilo);
        case 'ultimos3meses':
          return Vue.moment().subtract(2, 'month').startOf('month').format(estilo);
        case 'ultimos6meses':
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
        default:
          return Vue.moment().subtract(5, 'month').startOf('month').format(estilo);
      }
    },
    formatRangeDate() {
      if (this.actualFilter.valor.includes('--')) {
        const [desde, hasta] = this.actualFilter.valor.split('--');
        this.actualFilter.valorFormateado = `${desde} al ${hasta}`;
      } else {
        const foundPeriod = this.periodosDisponibles
          .find((period) => period.valor === this.actualFilter.valor);
        this.actualFilter.valorFormateado = foundPeriod.nombre;
      }
    },
    seleccionarRango(valor) {
      if (valor === 'personalizado') {
        this.tipoRangoFechaAvanzado = true;
        this.actualFilter.valor = valor;
      } else {
        this.actualFilter.valor = valor;
        this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
          if (filterApplied.campo === this.actualFilter.campo) {
            return {
              ...filterApplied,
              valor,
              valorFormateado: this.formatRangeDate()
            };
          }
          return filterApplied;
        });
      }
    },
    modificarFiltro(filter) {
      // this.clearOptions();
      this.editMood = true;
      this.actualFilter = filter;
      if (this.actualFilter.tipo === 'rangoFecha') {
        if (this.actualFilter.valor.includes('--')) {
          this.tipoRangoFechaAvanzado = true;
          const [desde, hasta] = filter.valor.split('--');
          this.rangoAvanzado.desde = desde;
          this.rangoAvanzado.hasta = hasta;
        } else {
          this.tipoRangoFechaAvanzado = false;
        }
      } else if (this.actualFilter.tipo === 'numero' || this.actualFilter.tipo === 'texto') {
        // Detectar coincidencia: flag guardado o presencia de * en el valor
        const valorArray = Array.isArray(this.actualFilter.valor)
          ? this.actualFilter.valor : [this.actualFilter.valor];
        const tieneWildcard = valorArray.some((v) => `${v}`.includes('*'));
        this.coincidencia = !!filter.coincidencia || tieneWildcard;

        // Mostrar los tags sin los * para que el usuario vea el texto limpio
        this.tags = valorArray.map((valor) => ({
          value: `${valor}`.replace(/^\*|\*$/g, '')
        }));
        this.tipoRango = this.actualFilter.valor.includes('--');
      }

      this.actualFilter.valor = filter.valor;
      this.$refs.configFiltro.show();
    },
    seleccionarTodos() {
      this.actualFilter.valor = Object.keys(this.actualFilter.opciones);
    },
    closeModal(filter) {
      this.removeFilter(filter);
      this.editMood = false;
    },
    verificarFiltrosAlCerrar() {
      // Si es filtro de texto en modo egestion con coincidencia activa, aplicar wildcards
      const aplicarCoincidencia = this.source === 'egestion'
        && this.actualFilter.tipo === 'texto'
        && this.coincidencia;

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === this.actualFilter.campo) {
          let { valor } = this.actualFilter;
          if (aplicarCoincidencia) {
            valor = this.wrapWildcards(this.actualFilter.valor);
          }
          return {
            ...filterApplied,
            valor,
            valorFormateado: this.actualFilter.valorFormateado,
            coincidencia: aplicarCoincidencia
          };
        }
        return filterApplied;
      }).filter((filter) => filter.valor.length > 0 && filter.valor !== '');

      // this.actualFilter = {};
      this.$refs.configFiltro.hide();
      this.editMood = false;
    },
    wrapWildcards(valor) {
      // Envuelve cada valor con *...* si el usuario no puso * explicito.
      // valor puede ser un array (tags) o un string.
      const wrap = (v) => {
        const trimmed = `${v}`.trim();
        if (!trimmed) return trimmed;
        return trimmed.includes('*') ? trimmed : `*${trimmed}*`;
      };
      if (Array.isArray(valor)) {
        return valor.map(wrap);
      }
      return wrap(valor);
    },
    setFilters(onMounted = false) {
      // Validar rango personalizado maximo 1 año cronologico
      if (this.rangeSelected.valor === 'personalizado') {
        const desde = Vue.moment(this.formatDate(this.rangeFrom));
        const hasta = Vue.moment(this.formatDate(this.rangeUntil));
        if (!desde.isValid() || !hasta.isValid()) {
          this.$vs.notify({
            title: 'Rango de fecha invalido',
            text: 'Debes seleccionar ambas fechas (desde y hasta).',
            color: 'warning',
            time: 4000
          });
          return;
        }
        if (hasta.isBefore(desde)) {
          this.$vs.notify({
            title: 'Rango de fecha invalido',
            text: 'La fecha "desde" no puede ser mayor a la fecha "hasta".',
            color: 'warning',
            time: 4000
          });
          return;
        }
        if (desde.isBefore(hasta.clone().subtract(1, 'year'))) {
          this.$vs.notify({
            title: 'Rango de fecha muy amplio',
            text: 'El rango de fechas no puede superar 1 año.',
            color: 'warning',
            time: 4000
          });
          return;
        }
      }

      const query = [];

      // para los filtros
      this.filtersView.filtrosFijos.forEach((filter) => {
        let { valor } = filter;
        if (filter.tipo === 'multi') {
          valor = Object.keys(filter.opciones);
        }
        query.push(`${filter.campo}:${valor}`);
      });

      // para los filtros disponibles que fueron aplicados

      this.filtrosAplicados.forEach((filter) => {
        if (filter.tipo === 'rangoFecha' && !filter.valor.includes('--')) {
          const inicio = this.formatoTipoRango(filter.valor);
          const fin = Vue.moment().format('YYYY-MM-DD');
          query.push(`${filter.campo}:${inicio}--${fin}`);
        } else if (filter.valor.length > 0 && filter.valor !== '') {
          query.push(`${filter.campo}:${filter.valor}`);
        }
      });
      const { rangeFrom, rangeUntil } = this;

      query.push(`fechaCreacion:${this.formatDate(rangeFrom) }--${ this.formatDate(rangeUntil)}`);
      this.$emit('filtros-aplicados', query.join('|'), onMounted);
    },
    formatDate(date) {
      if (date.includes('T')) {
        return date.split('T')[0];
      } return date;
    },
    searchAvailableFilters() {
      let { filtrosHabilitados } = this.filtersView;

      filtrosHabilitados = filtrosHabilitados
        .sort(({ nombre: a }, { nombre: b }) => a.localeCompare(b));
      this.filtrosDisponibles = { ...filtrosHabilitados };
    },
    setOptionsFilter(addedFilter) {
      let opciones = [];
      switch (addedFilter.tipo) {
        case 'selector': {
          opciones = this.actualFilter.opciones;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      return opciones;
    },
    addFilter(filter) {
      this.actualFilter = {};
      this.clearOptions();
      this.coincidencia = false;

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valor: filter.valor,
            valorFormateado: filter.valorFormateado
          };
        }
        return filterApplied;
      }).filter((filter2) => filter2.valor.length > 0 && filter2.valor !== '');

      const isApplied = this.filtrosAplicados
        .some((filterApplied) => filterApplied.campo === filter.campo);

      if (isApplied) {
        return;
      }

      this.actualFilter = filter;
      const addedFilter = filter;
      switch (addedFilter.tipo) {
        case 'selector': {
          this.actualFilter.opciones = this.setOptionsFilter(filter);
          break;
        }
        case 'multi': {
          this.selectAllOptions = false;
          break;
        }
        default: {
          console.log('format filtro default', this.actualFilter);
        }
      }
      this.filtrosAplicados.push(addedFilter);
      this.$refs.configFiltro.show();
    },
    selectFilter(filter) {
      this.actualFilter.valorFormateado = filter.valor
        .map((valor) => this.actualFilter.opciones[valor])
        .join(', ');

      this.filtrosAplicados = this.filtrosAplicados.map((filterApplied) => {
        if (filterApplied.campo === filter.campo) {
          return {
            ...filterApplied,
            valorFormateado: this.actualFilter.valorFormateado,
            valor: filter.valor
          };
        }
        return filterApplied;
      });
      if (this.actualFilter.valor.length === Object.keys(this.actualFilter.opciones).length) {
        this.selectAllOptions = true;
      }
    }
  },
  mounted() {
    this.periodosDisponibles = this.periodos.filter((periodo) => periodo.valor !== 'personalizado');
    this.searchAvailableFilters();
    this.setFilters(true);
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
